export default __webpack_public_path__ + "static/media/Hebrew.9e7dac26.svg";